import { BarChart3, Package, Truck, Users } from "lucide-react";
import ApplicationPage, { type ApplicationPageConfig } from "@/components/ApplicationPage";

const config: ApplicationPageConfig = {
  key: "logistics",
  slug: "logistica",
  icon: Truck,
  useCases: [
    { key: "fleet", icon: Truck },
    { key: "tracking", icon: Package },
    { key: "teams", icon: Users },
    { key: "analytics", icon: BarChart3 },
  ],
  benefits: ["costs", "delivery", "productivity", "visibility"],
  formApplication: "Logística",
};

const Logistica = () => <ApplicationPage config={config} />;

export default Logistica;
